import { Component, OnInit } from '@angular/core';
import { version } from '../../../../environments/version';
import { environment } from '../../../../environments/environment';
import { VersionService } from '../../service/version-service/version.service';


@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent {

  frontendVersion = "App " + version;
  environmentName = environment.frontendVersion;

  constructor(public versionService:VersionService) { }


}
